import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useRole } from '../../contexts/RoleContext';
import config from '../common/Config';
import { isBritWholesaleUi } from '../../utils/britWholesaleUi';
import {
    Button,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Box,
    ListItemText as MuiListItemText,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    Collapse,
    Divider,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { Iconify } from '../Minimal/src/components/iconify/iconify';
import { removeCurrentTabFromRegistry } from '../../utils/activeTabSession';
import { encryptPayload } from '../../utils/customerCrypto';
import { resolveCustomerApiEncrypt, clearCompanySettingsCache } from '../../utils/companySettingsCache';
import { clearUserRolesCache } from '../../utils/userRolesCache';
import { useCompanySettings } from '../../contexts/CompanySettingsContext';
import CustomerListPopup from '../sales/QuickOrder/component/CustomerListPopup';

const flyoutMenuSlotProps = {
    root: {
        sx: { pointerEvents: 'none' },
    },
    backdrop: {
        sx: { pointerEvents: 'none' },
    },
};

export const MegaMenu = () => {
    const { hasPermission, hasAnyPermission, isRole, getActiveRolePermissions, permissionsRevision } = useRole();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const accessToken = localStorage.getItem("accessToken");
    const userId = localStorage.getItem("userId");
    const isLimitedSalesRole = isRole(18) || isRole(19) || isRole(20);
    const isAccountantRole = isRole(22);
    const isSimplifiedNavRole = isLimitedSalesRole || isAccountantRole;
    const showEposNavItem = isRole(18) || hasPermission('POS');
    const isSinglePicking = localStorage.getItem("isSinglePicking");
    const shopifyConnectivity = localStorage.getItem("shopifyConnectivity");
    const amazonConnectivity = localStorage.getItem("amazonConnectivity");
    const showEmailTemplate = localStorage.getItem("showEmailTemplate");
    const showContraPrice = localStorage.getItem("showContraPrice");
    const [orderStatus, setOrderStatus] = useState(null);
    const [orderProcessSequence, setOrderProcessSequence] = useState(null);
    const [SiteName, setSiteName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [anchorEls, setAnchorEls] = useState({});
    const [reportsFlyout, setReportsFlyout] = useState(null);
    const reportsFlyoutRef = useRef(null);
    reportsFlyoutRef.current = reportsFlyout;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});
    const [customerListPopupOpen, setCustomerListPopupOpen] = useState(false);
    const location = useLocation();
    const token = localStorage.getItem("token");
    const isPurchase = false;
    const prefix = localStorage.getItem("accessToken");
    useEffect(() => {
        const site_name = localStorage.getItem("site_name");
        const storedFirstName = localStorage.getItem("first_name");
        const storedLastName = localStorage.getItem("last_name");

        if (site_name) {
            setSiteName(site_name);
        }
        if (storedFirstName) {
            setFirstName(storedFirstName);
        }
        if (storedLastName) {
            setLastName(storedLastName);
        }
    }, []);

    const { settings: companySettings } = useCompanySettings();

    useEffect(() => {
        if (!accessToken || !companySettings) {
            return;
        }
        if (companySettings.order_status !== undefined) {
            setOrderStatus(String(companySettings.order_status));
        }
        if (companySettings.order_process_sequence !== undefined) {
            setOrderProcessSequence(String(companySettings.order_process_sequence));
        }
    }, [accessToken, companySettings]);

    useEffect(() => {
        if (!isRole(20)) return undefined;
        const openCustomerList = () => setCustomerListPopupOpen(true);
        window.addEventListener('quickOrderOpenCustomerList', openCustomerList);
        return () => window.removeEventListener('quickOrderOpenCustomerList', openCustomerList);
    }, [permissionsRevision]);

    const openCustomerListPopup = () => {
        if (!isRole(20)) return;
        setCustomerListPopupOpen(true);
    };

    const handleMenuOpen = (event, menuName) => {
        event.stopPropagation();
        setAnchorEls((prev) => ({ ...prev, [menuName]: event.currentTarget }));
        setReportsFlyout(null);
    };

    const handleMenuClose = (menuName) => {
        setAnchorEls((prev) => ({ ...prev, [menuName]: null }));
        if (menuName === 'reports') {
            setReportsFlyout(null);
        }
    };

    const handleCloseAllMenus = () => {
        setAnchorEls({});
        setReportsFlyout(null);
    };

    const openReportsFlyout = (event, key) => {
        event.stopPropagation();
        setReportsFlyout({ key, anchor: event.currentTarget });
    };

    const isValidAnchor = (anchorEl) => {
        if (!anchorEl) return false;
        return document.body.contains(anchorEl);
    };

    const handleMenuItemClick = (menuName, callback) => {
        return (event) => {
            handleMenuClose(menuName);
            if (callback) callback(event);
        };
    };

    const handleMobileDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleMobileDrawerClose = () => {
        setMobileOpen(false);
    };

    const handleExpandMenu = (menuKey) => {
        setExpandedMenus((prev) => ({
            ...prev,
            [menuKey]: !prev[menuKey]
        }));
    };

    const isRouteActive = (routes) => {
        const currentPath = location.pathname.toLowerCase();
        return routes.some(route => {
            const routeLower = route.toLowerCase();
            return currentPath === routeLower ||
                currentPath.startsWith(routeLower + '/') ||
                currentPath.includes(routeLower + '/edit') ||
                currentPath.includes(routeLower + '/add') ||
                currentPath.includes(routeLower + '/view');
        });
    };

    useEffect(() => {
        if (mobileOpen) {
            setMobileOpen(false);
        }
        handleCloseAllMenus();
    }, [location.pathname]);

    // Render mobile menu for roles 18, 19, 20, 22
    const renderMobileMenuForRoles = () => {
        const menuItems = [];

        if (isRole(19)) {
            menuItems.push(
                { label: 'Dashboard', path: `/dashboard/${accessToken}/${userId}` },
                { label: (config.PREFIX === 'rhp' || accessToken === 'rhp' || accessToken === 'hp') ? 'Order List' : 'Incomplete Order List', path: '/sales/IncompleteOrderList' },
                { label: 'Sales Report', path: '/sales/epos_sales' }
            );
        } else if (isRole(18)) {
            menuItems.push({ label: 'Dashboard', path: `/dashboard/${accessToken}/${userId}` });
            if (showEposNavItem) {
                menuItems.push({ label: 'Epos', path: '/sales/epos/new' });
            }
            // menuItems.push({ label: 'Incomplete Order List', path: '/sales/IncompleteOrderList' });
            menuItems.push({ label: 'Sales Report', path: '/sales/epos_sales' });
            if (hasPermission('Promotion')) {
                menuItems.push({ label: 'Promotions', path: '/sales/offers/promotions' });
            }
        } else if (isRole(20)) {
            menuItems.push({ label: 'Dashboard', path: `/dashboard/${accessToken}/${userId}` });
            if (hasPermission('SalesQuickOrder')) {
                menuItems.push({ label: 'Order', path: '/sales/quick-order' });
            }
            if (hasPermission('Inventory_Report')) {
                menuItems.push({ label: 'Inventory Report', path: '/sales/InventoryReport' });
            }
            menuItems.push({ label: 'Sales Report', path: '/sales/epos_sales' });
            if (hasPermission('Promotion')) {
                menuItems.push({ label: 'Promotions', path: '/sales/offers/promotions' });
            }
            if (hasPermission('Customers')) {
                menuItems.push({
                    label: 'Customer',
                    path: '/customers',
                    onClick: () => {
                        openCustomerListPopup();
                    },
                    preventNavOnCustomerPopup: true,
                });
            }
            if (hasPermission('ReturnList')) {
                menuItems.push({ label: 'Return List', path: '/return_list' });
            }
        } else if (isAccountantRole) {
            menuItems.push({ label: 'Dashboard', path: `/dashboard/${accessToken}/${userId}` });
            menuItems.push({ label: 'Sales Report', path: '/sales/epos_sales' });
            if (hasPermission('ReturnList')) {
                menuItems.push({ label: 'Return List', path: '/return_list' });
            }
            menuItems.push({ label: 'Push to Sage', path: '/account/push_sage' });
        }

        return (
            <Drawer
                anchor="left"
                open={mobileOpen}
                onClose={handleMobileDrawerClose}
                PaperProps={{
                    sx: {
                        width: 280,
                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    },
                }}
            >
                <Box sx={{ p: 2, borderBottom: '1px solid rgba(8, 13, 17, 0.16)' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ color: '#F8991D', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '1rem' }}>
                            {SiteName}
                        </Box>
                        <IconButton onClick={handleMobileDrawerClose} size="small">
                            <Iconify icon="eva:close-fill" width={24} height={24} />
                        </IconButton>
                    </Box>
                </Box>
                <List sx={{ pt: 1 }}>
                    {menuItems.map((item) => {
                        const isActive = location.pathname === item.path ||
                            (item.path === '/sales/IncompleteOrderList' && (location.pathname === `/sales/IncompleteOrderList/${accessToken}/${userId}` || location.pathname === '/sales/IncompleteOrderList')) ||
                            (item.path === '/sales/InventoryReport' && (location.pathname === `/sales/InventoryReport/${accessToken}/${userId}` || location.pathname === '/sales/InventoryReport')) ||
                            (item.path === '/sales/epos_sales' && (location.pathname === `/sales/epos_sales/${accessToken}/${userId}` || location.pathname === '/sales/epos_sales'));
                        return (
                            <ListItem key={item.label} disablePadding>
                                <ListItemButton
                                    component={item.preventNavOnCustomerPopup ? 'button' : Link}
                                    to={item.preventNavOnCustomerPopup ? undefined : item.path}
                                    onClick={() => {
                                        if (typeof item.onClick === 'function') {
                                            item.onClick();
                                        }
                                        handleMobileDrawerClose();
                                    }}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        color: isActive ? '#F8991D' : '#212b36',
                                        fontWeight: isActive ? 600 : 400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            color: '#F8991D',
                                        },
                                    }}
                                >
                                    <ListItemText primary={item.label} />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                    <Divider sx={{ my: 1 }} />
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => {
                                handleMobileDrawerClose();
                                handleLogout();
                            }}
                            sx={{
                                py: 1.5,
                                px: 2,
                                color: '#212b36',
                                '&:hover': {
                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                },
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <Iconify icon="eva:log-out-fill" width={20} height={20} sx={{ color: '#637381' }} />
                            </ListItemIcon>
                            <ListItemText primary="Sign Out" />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Drawer>
        );
    };

    const handleLogout = () => {
        removeCurrentTabFromRegistry();
        try {
            const apiBCUrl = `${config.API_URL}/ws-logout`;
            void (async () => {
                const formData = new FormData();
                const settings = companySettings;
                const useEncrypt = resolveCustomerApiEncrypt(settings);
                if (useEncrypt) {
                    const ep = encryptPayload({ Platform: "Web" });
                    if (ep) {
                        formData.append("encrypted_payload", ep);
                    } else {
                        formData.append("Platform", "Web");
                    }
                } else {
                    formData.append("Platform", "Web");
                }
                await fetch(apiBCUrl, {
                    method: "POST",
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                    body: formData,
                    keepalive: true,
                });
            })();
        } catch (_) {}
        clearCompanySettingsCache();
        clearUserRolesCache();
        localStorage.removeItem("site_name");
        localStorage.removeItem("first_name");
        localStorage.removeItem("last_name");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("user_role");
        localStorage.removeItem("active_role_id");
        localStorage.removeItem("user_roles_data");
        localStorage.removeItem("role_permissions_map");
        localStorage.removeItem("user_permissions");
        localStorage.removeItem("isSinglePicking");
        localStorage.removeItem("shopifyConnectivity");
        localStorage.removeItem("amazonConnectivity");
        localStorage.removeItem("QuickBooksConnectivity");
        localStorage.removeItem("showEmailTemplate");
        localStorage.removeItem("showContraPrice");
        localStorage.removeItem("token");
        localStorage.removeItem("username");

        window.location.href = `${config.LOG_OUT}`;
    };

    if (isSimplifiedNavRole) {
        return (
            <>
                {renderMobileMenuForRoles()}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', borderBottom: '1px solid rgba(8, 13, 17, 0.1)' }}>
                    <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 1 }}>
                        {isMobile && (
                            <IconButton
                                onClick={handleMobileDrawerToggle}
                                sx={{ color: '#e27172' }}
                            >
                                <Iconify icon="eva:menu-fill" width={24} height={24} />
                            </IconButton>
                        )}
                        <span className="logo-area align-items-center scrollto me-auto me-lg-0"
                            style={{ color: '#F8991D', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '1rem' }}>
                            {SiteName}
                        </span>
                    </Box>

                    {!isMobile && (
                        <Box key={`limited-sales-nav-${permissionsRevision}`} sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, justifyContent: 'center' }}>
                            {isRole(19) && (
                                <>
                                    <Button
                                        component={Link}
                                        to={`/dashboard/${accessToken}/${userId}`}
                                        sx={{
                                            color: location.pathname === `/dashboard/${accessToken}/${userId}` ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Dashboard
                                    </Button>
                                    <Button
                                        component={Link}
                                        to="/sales/IncompleteOrderList"
                                        sx={{
                                            color: (location.pathname === `/sales/IncompleteOrderList/${accessToken}/${userId}` || location.pathname === '/sales/IncompleteOrderList') ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        {config.PREFIX === 'rhp' || accessToken === 'rhp' || accessToken === 'hp' ? 'Order List' : 'Incomplete Order List'}
                                    </Button>
                                    <Button
                                        component={Link}
                                        to="/sales/epos_sales"
                                        sx={{
                                            color: (location.pathname === `/sales/epos_sales/${accessToken}/${userId}` || location.pathname === '/sales/epos_sales') ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Sales Report
                                    </Button>
                                </>
                            )}

                            {isRole(18) && (
                                <>
                                    <Button
                                        component={Link}
                                        to={`/dashboard/${accessToken}/${userId}`}
                                        sx={{
                                            color: location.pathname === `/dashboard/${accessToken}/${userId}` ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Dashboard
                                    </Button>
                                    {showEposNavItem && (
                                        <Button
                                            component={Link}
                                            to="/sales/epos/new"
                                            sx={{
                                                color: location.pathname === '/sales/epos/new' ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Epos
                                        </Button>
                                    )}

                                    {/* <Button
                                        component={Link}
                                        to="/sales/IncompleteOrderList"
                                        sx={{
                                            color: location.pathname === "/sales/IncompleteOrderList" ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Incomplete Order List
                                    </Button> */}

                                    <Button
                                        component={Link}
                                        to="/sales/epos_sales"
                                        sx={{
                                            color: location.pathname === "/sales/epos_sales" ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Sales Report
                                    </Button>
                                    {hasPermission('Promotion') && (
                                        <Button
                                            component={Link}
                                            to="/sales/offers/promotions"
                                            sx={{
                                                color: location.pathname === '/sales/offers/promotions' ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Promotions
                                        </Button>
                                    )}
                                </>
                            )}

                            {isRole(20) && (
                                <>
                                    <Button
                                        component={Link}
                                        to={`/dashboard/${accessToken}/${userId}`}
                                        sx={{
                                            color: location.pathname === `/dashboard/${accessToken}/${userId}` ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Dashboard
                                    </Button>
                                    {hasPermission('SalesQuickOrder') && (
                                        <Button
                                            component={Link}
                                            to="/sales/quick-order"
                                            sx={{
                                                color: location.pathname === "/sales/quick-order" ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Order
                                        </Button>
                                    )}
                                    {hasPermission('Inventory_Report') && (
                                        <Button
                                            component={Link}
                                            to="/sales/InventoryReport"
                                            sx={{
                                                color: location.pathname === "/sales/InventoryReport" ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Inventory Report
                                        </Button>
                                    )}
                                    <Button
                                        component={Link}
                                        to="/sales/epos_sales"
                                        sx={{
                                            color: location.pathname === "/sales/epos_sales" ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Sales Report
                                    </Button>
                                    {hasPermission('Promotion') && (
                                        <Button
                                            component={Link}
                                            to="/sales/offers/promotions"
                                            sx={{
                                                color: location.pathname === '/sales/offers/promotions' ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Promotions
                                        </Button>
                                    )}
                                    {hasPermission('Customers') && (
                                        <Button
                                            type="button"
                                            onClick={openCustomerListPopup}
                                            sx={{
                                                color: "#000",
                                                textTransform: "none",
                                                fontSize: "0.8rem",
                                                fontWeight: 600,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Customer
                                        </Button>
                                    )}
                                    {hasPermission('ReturnList') && (
                                        <Button
                                            component={Link}
                                            to="/return_list"
                                            sx={{
                                                color: location.pathname === "/return_list" ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.8rem",
                                                fontWeight: 600,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Return List
                                        </Button>
                                    )}
                                </>
                            )}

                            {isAccountantRole && (
                                <>
                                    <Button
                                        component={Link}
                                        to={`/dashboard/${accessToken}/${userId}`}
                                        sx={{
                                            color: location.pathname === `/dashboard/${accessToken}/${userId}` ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Dashboard
                                    </Button>
                                    <Button
                                        component={Link}
                                        to="/sales/epos_sales"
                                        sx={{
                                            color: (location.pathname === `/sales/epos_sales/${accessToken}/${userId}` || location.pathname === '/sales/epos_sales') ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Sales Report
                                    </Button>
                                    {hasPermission('ReturnList') && (
                                        <Button
                                            component={Link}
                                            to="/return_list"
                                            sx={{
                                                color: location.pathname === "/return_list" ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,
                                                px: 1.8,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                },
                                                "&:active": {
                                                    color: "#F8991D"
                                                }
                                            }}
                                        >
                                            Return List
                                        </Button>
                                    )}
                                    <Button
                                        component={Link}
                                        to="/account/push_sage"
                                        sx={{
                                            color: location.pathname === "/account/push_sage" ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Push to Sage
                                    </Button>
                                </>
                            )}
                        </Box>
                    )}

                    {!isMobile && (
                        <Box sx={{ flexShrink: 0, display: 'flex' }}>
                            <ul style={{ display: 'flex', alignItems: 'center', listStyle: 'none', margin: 0, padding: 0 }}>
                                <li>
                                    <Button
                                        onClick={(e) => handleMenuOpen(e, "profile")}
                                        sx={{
                                            color: "#F8991D",
                                            textTransform: "none",
                                            fontSize: "1rem",
                                            fontWeight: 600,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)"
                                            }
                                        }}
                                    >
                                        {firstName} {lastName ? lastName : ""}
                                    </Button>
                                    {anchorEls.profile && isValidAnchor(anchorEls.profile) && (
                                        <Menu
                                            anchorEl={anchorEls.profile}
                                            open={true}
                                            onClose={() => handleMenuClose("profile")}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            PaperProps={{
                                                sx: {
                                                    mt: 1,
                                                    minWidth: 180,
                                                    boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                    borderRadius: 1,
                                                },
                                            }}
                                        >
                                            <MenuItem
                                                onClick={() => {
                                                    handleMenuClose("profile");
                                                    handleLogout();
                                                }}
                                                sx={{
                                                    color: "#212b36",
                                                    "&:hover": {
                                                        backgroundColor: "rgba(145, 158, 171, 0.08)",
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                <ListItemIcon>
                                                    <Iconify icon="eva:log-out-fill" width={20} height={20} sx={{ color: "#637381" }} />
                                                </ListItemIcon>
                                                <ListItemText>Sign Out</ListItemText>
                                            </MenuItem>
                                        </Menu>
                                    )}
                                </li>
                            </ul>
                        </Box>
                    )}
                </Box>
                {isRole(20) ? (
                    <CustomerListPopup
                        open={customerListPopupOpen}
                        onClose={() => setCustomerListPopupOpen(false)}
                    />
                ) : null}
            </>
        );
    }

    // Render mobile menu item with collapsible submenu
    const renderMobileMenuItem = (item, depth = 0) => {
        const hasChildren = item.children && item.children.length > 0;
        const menuKey = item.key || item.label;
        const isExpanded = expandedMenus[menuKey] || false;
        const isActive = item.path && (location.pathname === item.path || location.pathname.includes(item.path));

        if (hasChildren) {
            return (
                <React.Fragment key={menuKey}>
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => handleExpandMenu(menuKey)}
                            sx={{
                                py: 1.5,
                                px: 2 + depth * 2,
                                '&:hover': {
                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                },
                            }}
                        >
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    sx: {
                                        fontWeight: isActive ? 600 : 400,
                                        color: isActive ? '#F8991D' : '#212b36',
                                    }
                                }}
                            />
                            <Iconify
                                icon={isExpanded ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                width={20}
                                height={20}
                            />
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {item.children.map((child) => renderMobileMenuItem(child, depth + 1))}
                        </List>
                    </Collapse>
                </React.Fragment>
            );
        }

        return (
            <ListItem key={menuKey} disablePadding>
                <ListItemButton
                    component={Link}
                    to={item.path}
                    onClick={handleMobileDrawerClose}
                    sx={{
                        py: 1.5,
                        px: 2 + depth * 2,
                        color: isActive ? '#F8991D' : '#212b36',
                        fontWeight: isActive ? 600 : 400,
                        '&:hover': {
                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                            color: '#F8991D',
                        },
                    }}
                >
                    <ListItemText primary={item.label} />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <>
            {isMobile && (
                <Drawer
                    anchor="left"
                    open={mobileOpen}
                    onClose={handleMobileDrawerClose}
                    PaperProps={{
                        sx: {
                            width: 280,
                            boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        },
                    }}
                >
                    <Box sx={{ p: 2, borderBottom: '1px solid rgba(8, 13, 17, 0.16)' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Link
                                to={`/dashboard/${accessToken}/${userId}`}
                                onClick={handleMobileDrawerClose}
                                style={{ textDecoration: 'none', color: '#F8991D', fontWeight: 'bold', fontSize: '1rem', textTransform: 'uppercase' }}
                            >
                                {SiteName}
                            </Link>
                            <IconButton onClick={handleMobileDrawerClose} size="small">
                                <Iconify icon="eva:close-fill" width={24} height={24} />
                            </IconButton>
                        </Box>
                    </Box>
                    <List sx={{ pt: 1, overflow: 'auto', maxHeight: 'calc(100vh - 80px)' }}>
                        {!isPurchase && (
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to={`/dashboard/${accessToken}/${userId}`}
                                    onClick={handleMobileDrawerClose}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        color: location.pathname === `/dashboard/${accessToken}/${userId}` ? '#F8991D' : '#212b36',
                                        fontWeight: location.pathname === `/dashboard/${accessToken}/${userId}` ? 600 : 400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            color: '#F8991D',
                                        },
                                    }}
                                >
                                    <ListItemText primary="Dashboard" />
                                </ListItemButton>
                            </ListItem>
                        )}

                        {!isPurchase && hasPermission('Company Settings') && (
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to="/dashboard/company-settings"
                                    onClick={handleMobileDrawerClose}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        color: location.pathname === "/dashboard/company-settings" ? '#F8991D' : '#212b36',
                                        fontWeight: location.pathname === "/dashboard/company-settings" ? 600 : 400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            color: '#F8991D',
                                        },
                                    }}
                                >
                                    <ListItemText primary="Company Settings" />
                                </ListItemButton>
                            </ListItem>
                        )}

                        {!isPurchase && (hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to="/settings/change_permissions/1"
                                    onClick={handleMobileDrawerClose}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        color: location.pathname.includes("/settings/change_permissions") ? '#F8991D' : '#212b36',
                                        fontWeight: location.pathname.includes("/settings/change_permissions") ? 600 : 400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            color: '#F8991D',
                                        },
                                    }}
                                >
                                    <ListItemText primary="Role Permissions" />
                                </ListItemButton>
                            </ListItem>
                        )}

                        {!isPurchase && (hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to="/settings/product_form_fields"
                                    onClick={handleMobileDrawerClose}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        color: location.pathname.includes("/settings/product_form_fields") ? '#F8991D' : '#212b36',
                                        fontWeight: location.pathname.includes("/settings/product_form_fields") ? 600 : 400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            color: '#F8991D',
                                        },
                                    }}
                                >
                                    <ListItemText primary="Product" />
                                </ListItemButton>
                            </ListItem>
                        )}

                        {!isPurchase && (hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to="/settings/customer_form_fields"
                                    onClick={handleMobileDrawerClose}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        color: location.pathname.includes("/settings/customer_form_fields") ? '#F8991D' : '#212b36',
                                        fontWeight: location.pathname.includes("/settings/customer_form_fields") ? 600 : 400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            color: '#F8991D',
                                        },
                                    }}
                                >
                                    <ListItemText primary="Customer" />
                                </ListItemButton>
                            </ListItem>
                        )}

                        {!isPurchase && ((hasAnyPermission(['NewSales', 'SalesHistory', 'SalesQuickOrder', 'HoldList']) || isRole(20)) || hasPermission('HoldList') || hasPermission('SalesHistory')) && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => handleExpandMenu('sales')}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary="Sales"
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: isRouteActive(['/sales/newsales', '/sales/shistory', '/sales/reject_sales', '/sales/IncompleteOrderList', '/sales/quick-order', '/sales/inventoryreport', '/sales/epos', '/sales/holdList']) ? 600 : 400,
                                                    color: isRouteActive(['/sales/newsales', '/sales/shistory', '/sales/reject_sales', '/sales/IncompleteOrderList', '/sales/quick-order', '/sales/inventoryreport', '/sales/epos', '/sales/holdList']) ? '#F8991D' : '#212b36',
                                                }
                                            }}
                                        />
                                        <Iconify
                                            icon={expandedMenus['sales'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                            width={20}
                                            height={20}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={expandedMenus['sales'] || false} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {((orderProcessSequence === "4") || (orderStatus === "2" && orderProcessSequence === "2")) ? (
                                            <>
                                                {hasPermission('HoldList') && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/holdList"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/holdList" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/holdList" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Hold List" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {hasPermission('SalesHistory') && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/shistory"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/shistory" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/shistory" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Order History" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {hasPermission('NewSales') && !(orderStatus === "2" && orderProcessSequence === "1") && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/newsales"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/newsales" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/newsales" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="New Sales" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {hasPermission('SalesHistory') && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/shistory"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/shistory" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/shistory" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Order History" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {hasPermission('HoldList') && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/holdList"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/holdList" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/holdList" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Hold List" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {hasPermission('SalesHistory') && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/reject_sales"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/reject_sales" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/reject_sales" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Reject Sales History" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {config.PREFIX === "atr" && isRole(8) && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/IncompleteOrderList"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/IncompleteOrderList" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/IncompleteOrderList" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Customer Incomplete Order" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {isRole(20) && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/quick-order"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/quick-order" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/quick-order" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Order" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {hasPermission('Inventory_Report') && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/InventoryReport"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/InventoryReport" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/InventoryReport" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Inventory Report" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                                {showEposNavItem && (
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            component={Link}
                                                            to="/sales/epos/new"
                                                            onClick={handleMobileDrawerClose}
                                                            sx={{
                                                                py: 1.5,
                                                                px: 4,
                                                                color: location.pathname === "/sales/epos/new" ? '#F8991D' : '#212b36',
                                                                fontWeight: location.pathname === "/sales/epos/new" ? 600 : 400,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                    color: '#F8991D',
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText primary="Epos" />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )}
                                            </>
                                        )}
                                    </List>
                                </Collapse>
                            </>
                        )}

                        {!isPurchase && hasAnyPermission(['CreatePicking', 'PickingList', 'PickingHistory', 'ProformaInvoice']) && orderStatus !== "3" && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => handleExpandMenu('picking')}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary="Picking"
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: isRouteActive(['/picking/picking_list', '/picking/single_picking_list', '/picking/short_qty', '/picking/proforma']) ? 600 : 400,
                                                    color: isRouteActive(['/picking/picking_list', '/picking/single_picking_list', '/picking/short_qty', '/picking/proforma']) ? '#F8991D' : '#212b36',
                                                }
                                            }}
                                        />
                                        <Iconify
                                            icon={expandedMenus['picking'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                            width={20}
                                            height={20}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={expandedMenus['picking'] || false} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {hasPermission('PickingList') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to={isSinglePicking === 'Y' ? "/picking/single_picking_list" : "/picking/picking_list"}
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: (location.pathname === "/picking/single_picking_list" || location.pathname === "/picking/picking_list") ? '#F8991D' : '#212b36',
                                                        fontWeight: (location.pathname === "/picking/single_picking_list" || location.pathname === "/picking/picking_list") ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Picking List" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('PickingHistory') && isSinglePicking === 'N' && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/picking/short_qty"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/picking/short_qty" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/picking/short_qty" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Short QTY" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('ProformaInvoice') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/picking/proforma"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/picking/proforma" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/picking/proforma" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Confirm Picking" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                    </List>
                                </Collapse>
                            </>
                        )}

                        {hasAnyPermission(['CreateManifest', 'Trip']) && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => handleExpandMenu('delivery')}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary="Dispatch & Deliveries"
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: isRouteActive(['/delivery/route_planing', '/manifest_list', '/open_trips', '/complete_trips']) ? 600 : 400,
                                                    color: isRouteActive(['/delivery/route_planing', '/manifest_list', '/open_trips', '/complete_trips']) ? '#F8991D' : '#212b36',
                                                }
                                            }}
                                        />
                                        <Iconify
                                            icon={expandedMenus['delivery'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                            width={20}
                                            height={20}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={expandedMenus['delivery'] || false} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {hasPermission('CreateManifest') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/delivery/route_planing"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/delivery/route_planing" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/delivery/route_planing" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Create Manifest" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('CreateManifest') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/manifest_list"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/manifest_list" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/manifest_list" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Manifest List" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('Trip') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/open_trips"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/open_trips" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/open_trips" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Open Trip" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('Trip') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/complete_trips"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/complete_trips" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/complete_trips" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Complete Trip" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                    </List>
                                </Collapse>
                            </>
                        )}

                        {hasAnyPermission(['Product', 'ProductsPriceVariation', 'Supplier', 'Users', 'ProductCategories', 'Brand', 'Unit', 'Customers', 'CreditFacility', 'Adjustments', 'StockTake', 'OrderProductDiscount', 'Catalogue', 'Shopify Product List', 'Amazon Product List']) && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => handleExpandMenu('master')}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary="Master"
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: isRouteActive(['/products', '/products_price_variation', '/supplier', '/users', '/product_category', '/Brands', '/Units', '/customers', '/ContraList', '/shopifyProductList', '/amazonProductList']) ? 600 : 400,
                                                    color: isRouteActive(['/products', '/products_price_variation', '/supplier', '/users', '/product_category', '/Brands', '/Units', '/customers', '/ContraList', '/shopifyProductList', '/amazonProductList']) ? '#F8991D' : '#212b36',
                                                }
                                            }}
                                        />
                                        <Iconify
                                            icon={expandedMenus['master'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                            width={20}
                                            height={20}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={expandedMenus['master'] || false} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {hasPermission('Product') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/products"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/products" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/products" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Products" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {config.PREFIX === 'tsc' && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/shopifyProductList"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/shopifyProductList" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/shopifyProductList" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Shopify List" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('ProductsPriceVariation') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/products_price_variation"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/products_price_variation" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/products_price_variation" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Product Price Variation" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('Supplier') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/supplier"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/supplier" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/supplier" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Suppliers" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('Users') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/users"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/users" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/users" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Users" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('ProductCategories') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/product_category"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/product_category" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/product_category" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Product Categories" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('Brand') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/Brands"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/Brands" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/Brands" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Brands" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('Unit') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/Units"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/Units" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/Units" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Units" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('Customers') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/customers"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/customers" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/customers" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Customers" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {showContraPrice === 'Y' && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/ContraList"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/ContraList" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/ContraList" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Contra Price Customers" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {shopifyConnectivity === 'Y' && hasPermission('Shopify Product List') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/shopifyProductList"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/shopifyProductList" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/shopifyProductList" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Shopify Product List" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {amazonConnectivity === 'Y' && hasPermission('Amazon Product List') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/amazonProductList"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/amazonProductList" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/amazonProductList" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Amazon Product List" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                    </List>
                                </Collapse>
                            </>
                        )}

                        {(isPurchase || hasAnyPermission(['CustomernotOrder', 'DriverReport', 'InventorySales', 'Inventory_Report', 'MISreport', 'Cross-Off', 'Sales-Rep', 'ProfitLoss'])) && (
                            <>
                                {isPurchase ? (
                                    <>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                onClick={() => handleExpandMenu('reports')}
                                                sx={{
                                                    py: 1.5,
                                                    px: 2,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                    },
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Report"
                                                    primaryTypographyProps={{
                                                        sx: {
                                                            fontWeight: isRouteActive(['/reports']) ? 600 : 400,
                                                            color: isRouteActive(['/reports']) ? '#F8991D' : '#212b36',
                                                        }
                                                    }}
                                                />
                                                <Iconify
                                                    icon={expandedMenus['reports'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                                    width={20}
                                                    height={20}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <Collapse in={expandedMenus['reports'] || false} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                <ListItem disablePadding>
                                                    <ListItemButton
                                                        component={Link}
                                                        to="/reports/PurchaseOrderReport"
                                                        onClick={handleMobileDrawerClose}
                                                        sx={{
                                                            py: 1.5,
                                                            px: 4,
                                                            color: location.pathname === "/reports/PurchaseOrderReport" ? '#F8991D' : '#212b36',
                                                            fontWeight: location.pathname === "/reports/PurchaseOrderReport" ? 600 : 400,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                color: '#F8991D',
                                                            },
                                                        }}
                                                    >
                                                        <ListItemText primary="Purchase Report" />
                                                    </ListItemButton>
                                                </ListItem>
                                            </List>
                                        </Collapse>
                                    </>
                                ) : (
                                    <>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                onClick={() => handleExpandMenu('reports')}
                                                sx={{
                                                    py: 1.5,
                                                    px: 2,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                    },
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Report"
                                                    primaryTypographyProps={{
                                                        sx: {
                                                            fontWeight: isRouteActive(['/reports']) ? 600 : 400,
                                                            color: isRouteActive(['/reports']) ? '#F8991D' : '#212b36',
                                                        }
                                                    }}
                                                />
                                                <Iconify
                                                    icon={expandedMenus['reports'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                                    width={20}
                                                    height={20}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                        <Collapse in={expandedMenus['reports'] || false} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                <ListItem disablePadding>
                                                    <ListItemButton
                                                        onClick={() => handleExpandMenu('reports-sales')}
                                                        sx={{
                                                            py: 1.5,
                                                            px: 4,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            },
                                                        }}
                                                    >
                                                        <ListItemText primary="Sales" />
                                                        <Iconify
                                                            icon={expandedMenus['reports-sales'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                <Collapse in={expandedMenus['reports-sales'] || false} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/sales_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/sales_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/sales_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Sales Rep Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/inventory_sales_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/inventory_sales_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/inventory_sales_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Inventory Sales Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/sales_product_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/sales_product_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/sales_product_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Sales Products Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/customer_not_order_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/customer_not_order_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/customer_not_order_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Customer Not Order" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/dsr_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/dsr_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/dsr_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="DSR Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/DaySummaryReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/DaySummaryReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/DaySummaryReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Day Summary Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/SalesOrderReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/SalesOrderReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/SalesOrderReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Sales Order Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        {(config.PREFIX == "eve" || config.PREFIX == "ve" || config.PREFIX == "tsc") && (
                                                        <>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/PushInvoiceReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/PushInvoiceReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/PushInvoiceReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Push Invoice Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/PushCreditNoteReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/PushCreditNoteReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/PushCreditNoteReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Push Credit Note Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        </>
                                                        )}
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/CustomerMonthlySalesReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/CustomerMonthlySalesReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/CustomerMonthlySalesReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Customer Monthly Sales Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </Collapse>
                                                <ListItem disablePadding>
                                                    <ListItemButton
                                                        onClick={() => handleExpandMenu('reports-account')}
                                                        sx={{
                                                            py: 1.5,
                                                            px: 4,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            },
                                                        }}
                                                    >
                                                        <ListItemText primary="Account" />
                                                        <Iconify
                                                            icon={expandedMenus['reports-account'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                <Collapse in={expandedMenus['reports-account'] || false} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/profit_loss_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/profit_loss_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/profit_loss_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Profit and Loss" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/TransactionsReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/TransactionsReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/TransactionsReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Transaction Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/mis_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/mis_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/mis_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="MIS Order Wise" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/mis_product_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/mis_product_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/mis_product_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="MIS Product Wise" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </Collapse>
                                                <ListItem disablePadding>
                                                    <ListItemButton
                                                        onClick={() => handleExpandMenu('reports-inventory')}
                                                        sx={{
                                                            py: 1.5,
                                                            px: 4,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            },
                                                        }}
                                                    >
                                                        <ListItemText primary="Inventory" />
                                                        <Iconify
                                                            icon={expandedMenus['reports-inventory'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                <Collapse in={expandedMenus['reports-inventory'] || false} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/stock_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/stock_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/stock_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Stock Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/batchWise_stock_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/batchWise_stock_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/batchWise_stock_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Batch Wise Stock Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        {isBritWholesaleUi() && (
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/brit_dual_stock"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/brit_dual_stock" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/brit_dual_stock" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Brit dual stock" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        )}
                                                        {isBritWholesaleUi() && (
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/brit_stock_transfer_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/brit_stock_transfer_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/brit_stock_transfer_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Brit stock transfer report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        )}
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/NewProductsTransactionReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/NewProductsTransactionReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/NewProductsTransactionReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Products Transaction Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        {hasPermission('Inventory_Report') && (
                                                            <ListItem disablePadding>
                                                                <ListItemButton
                                                                    component={Link}
                                                                    to="/sales/InventoryReport"
                                                                    onClick={handleMobileDrawerClose}
                                                                    sx={{
                                                                        py: 1.5,
                                                                        px: 6,
                                                                        color: location.pathname === "/sales/InventoryReport" ? '#F8991D' : '#212b36',
                                                                        fontWeight: location.pathname === "/sales/InventoryReport" ? 600 : 400,
                                                                        '&:hover': {
                                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                            color: '#F8991D',
                                                                        },
                                                                    }}
                                                                >
                                                                    <ListItemText primary="Inventory Report" />
                                                                </ListItemButton>
                                                            </ListItem>
                                                        )}
                                                    </List>
                                                </Collapse>
                                                <ListItem disablePadding>
                                                    <ListItemButton
                                                        onClick={() => handleExpandMenu('reports-other')}
                                                        sx={{
                                                            py: 1.5,
                                                            px: 4,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            },
                                                        }}
                                                    >
                                                        <ListItemText primary="Other" />
                                                        <Iconify
                                                            icon={expandedMenus['reports-other'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                <Collapse in={expandedMenus['reports-other'] || false} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/missing_order"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/missing_order" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/missing_order" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Cross Off Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/lat_long_report"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/lat_long_report" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/lat_long_report" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Order Location Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </Collapse>
                                                <ListItem disablePadding>
                                                    <ListItemButton
                                                        onClick={() => handleExpandMenu('reports-purchase')}
                                                        sx={{
                                                            py: 1.5,
                                                            px: 4,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            },
                                                        }}
                                                    >
                                                        <ListItemText primary="Purchase" />
                                                        <Iconify
                                                            icon={expandedMenus['reports-purchase'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                                            width={20}
                                                            height={20}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                <Collapse in={expandedMenus['reports-purchase'] || false} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        <ListItem disablePadding>
                                                            <ListItemButton
                                                                component={Link}
                                                                to="/reports/PurchaseOrderReport"
                                                                onClick={handleMobileDrawerClose}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 6,
                                                                    color: location.pathname === "/reports/PurchaseOrderReport" ? '#F8991D' : '#212b36',
                                                                    fontWeight: location.pathname === "/reports/PurchaseOrderReport" ? 600 : 400,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                                        color: '#F8991D',
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText primary="Purchase Report" />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    </List>
                                                </Collapse>
                                            </List>
                                        </Collapse>
                                    </>
                                )}
                            </>
                        )}

                        {(hasAnyPermission(['PurchasesOrder', 'PurchasesHistory', 'StockAdjustment']) || isPurchase) && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => handleExpandMenu('purchases')}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary="Purchases"
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: isRouteActive(['/purchases/purchases_order', '/purchases/purchases_grn', '/purchases/StockAdjustment']) ? 600 : 400,
                                                    color: isRouteActive(['/purchases/purchases_order', '/purchases/purchases_grn', '/purchases/StockAdjustment']) ? '#F8991D' : '#212b36',
                                                }
                                            }}
                                        />
                                        <Iconify
                                            icon={expandedMenus['purchases'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                            width={20}
                                            height={20}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={expandedMenus['purchases'] || false} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {hasPermission('PurchasesOrder') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/purchases/purchases_order"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/purchases/purchases_order" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/purchases/purchases_order" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Purchases Order" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('PurchasesHistory') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}    
                                                    to="/purchases/purchases_grn"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/purchases/purchases_grn" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/purchases/purchases_grn" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Purchases History" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('StockAdjustment') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/purchases/StockAdjustment"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/purchases/StockAdjustment" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/purchases/StockAdjustment" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Stock Adjustment" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                    </List>
                                </Collapse>
                            </>
                        )}

                        {hasAnyPermission(['ReceivedPayments', 'CustomerAccount', 'PaymentLedger', 'BankLedger']) && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => handleExpandMenu('account')}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary="Account"
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: isRouteActive(['/account/push_sage', '/account/payments', '/account/customer_accounts', '/account/customer_transaction_enquiry', '/account/supplier_ledger', '/account/payment_ladger', '/account/my_ledger', '/account/product_ledger', '/reports/payment_collection', '/stock_take/history']) ? 600 : 400,
                                                    color: isRouteActive(['/account/push_sage', '/account/payments', '/account/customer_accounts', '/account/customer_transaction_enquiry', '/account/supplier_ledger', '/account/payment_ladger', '/account/my_ledger', '/account/product_ledger', '/reports/payment_collection', '/stock_take/history']) ? '#F8991D' : '#212b36',
                                                }
                                            }}
                                        />
                                        <Iconify
                                            icon={expandedMenus['account'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                            width={20}
                                            height={20}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={expandedMenus['account'] || false} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {accessToken === "dds" && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/account/push_sage"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/account/push_sage" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/account/push_sage" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Push to Sage" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('ReceivedPayments') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/account/payments"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/account/payments" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/account/payments" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Received Payments" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('CustomerAccount') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/account/customer_accounts"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/account/customer_accounts" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/account/customer_accounts" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Customer Accounts" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {(config.PREFIX === 'rhp' || config.PREFIX === 'hp' || accessToken === 'rhp' || accessToken === 'hp') && (hasPermission('CustomerTransactionEnquiry') || hasPermission('CustomerAccount')) && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/account/customer_transaction_enquiry"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/account/customer_transaction_enquiry" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/account/customer_transaction_enquiry" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Customer Transaction Enquiry" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                component={Link}
                                                to="/account/supplier_ledger"
                                                onClick={handleMobileDrawerClose}
                                                sx={{
                                                    py: 1.5,
                                                    px: 4,
                                                    color: location.pathname === "/account/supplier_ledger" ? '#F8991D' : '#212b36',
                                                    fontWeight: location.pathname === "/account/supplier_ledger" ? 600 : 400,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                        color: '#F8991D',
                                                    },
                                                }}
                                            >
                                                <ListItemText primary="Supplier Ledger" />
                                            </ListItemButton>
                                        </ListItem>
                                        {hasPermission('PaymentLedger') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/account/payment_ladger"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/account/payment_ladger" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/account/payment_ladger" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Payment Ledger" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        {hasPermission('PaymentLedger') && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/account/my_ledger"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/account/my_ledger" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/account/my_ledger" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="My Ledger" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                component={Link}
                                                to="/account/product_ledger"
                                                onClick={handleMobileDrawerClose}
                                                sx={{
                                                    py: 1.5,
                                                    px: 4,
                                                    color: location.pathname === "/account/product_ledger" ? '#F8991D' : '#212b36',
                                                    fontWeight: location.pathname === "/account/product_ledger" ? 600 : 400,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                        color: '#F8991D',
                                                    },
                                                }}
                                            >
                                                <ListItemText primary="Product Ledger" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                component={Link}
                                                to="/reports/payment_collection"
                                                onClick={handleMobileDrawerClose}
                                                sx={{
                                                    py: 1.5,
                                                    px: 4,
                                                    color: location.pathname === "/reports/payment_collection" ? '#F8991D' : '#212b36',
                                                    fontWeight: location.pathname === "/reports/payment_collection" ? 600 : 400,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                        color: '#F8991D',
                                                    },
                                                }}
                                            >
                                                <ListItemText primary="Payment Collected" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                component={Link}
                                                to="/stock_take/history"
                                                onClick={handleMobileDrawerClose}
                                                sx={{
                                                    py: 1.5,
                                                    px: 4,
                                                    color: location.pathname === "/stock_take/history" ? '#F8991D' : '#212b36',
                                                    fontWeight: location.pathname === "/stock_take/history" ? 600 : 400,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                        color: '#F8991D',
                                                    },
                                                }}
                                            >
                                                <ListItemText primary="Stock Take" />
                                            </ListItemButton>
                                        </ListItem>
                                    </List>
                                </Collapse>
                            </>
                        )}

                        {hasPermission('ReturnList') && (
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to="/return_list"
                                    onClick={handleMobileDrawerClose}
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        color: location.pathname === "/return_list" ? '#F8991D' : '#212b36',
                                        fontWeight: location.pathname === "/return_list" ? 600 : 400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            color: '#F8991D',
                                        },
                                    }}
                                >
                                    <ListItemText primary="Return" />
                                </ListItemButton>
                            </ListItem>
                        )}

                        {hasAnyPermission(['Catalogue', 'SliderSettings', 'Promotions', 'EmailTemplate']) && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => handleExpandMenu('promotions')}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            '&:hover': {
                                                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary="Setting"
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontWeight: isRouteActive(['/Catalogue', '/slider_settings', '/Promotions/Promos', '/emailTemplate']) ? 600 : 400,
                                                    color: isRouteActive(['/Catalogue', '/slider_settings', '/Promotions/Promos', '/emailTemplate']) ? '#F8991D' : '#212b36',
                                                }
                                            }}
                                        />
                                        <Iconify
                                            icon={expandedMenus['promotions'] ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill"}
                                            width={20}
                                            height={20}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={expandedMenus['promotions'] || false} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {(accessToken != "eve" && accessToken != "ve" && accessToken != "ayt") && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/Catalogue"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/Catalogue" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/Catalogue" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Catalogue" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                component={Link}
                                                to="/slider_settings"
                                                onClick={handleMobileDrawerClose}
                                                sx={{
                                                    py: 1.5,
                                                    px: 4,
                                                    color: location.pathname === "/slider_settings" ? '#F8991D' : '#212b36',
                                                    fontWeight: location.pathname === "/slider_settings" ? 600 : 400,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                        color: '#F8991D',
                                                    },
                                                }}
                                            >
                                                <ListItemText primary="Slider Settings" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                component={Link}
                                                to="/Promotions/Promos"
                                                onClick={handleMobileDrawerClose}
                                                sx={{
                                                    py: 1.5,
                                                    px: 4,
                                                    color: location.pathname === "/Promotions/Promos" ? '#F8991D' : '#212b36',
                                                    fontWeight: location.pathname === "/Promotions/Promos" ? 600 : 400,
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                        color: '#F8991D',
                                                    },
                                                }}
                                            >
                                                <ListItemText primary="Promotions" />
                                            </ListItemButton>
                                        </ListItem>
                                        {showEmailTemplate === 'Y' && (
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    component={Link}
                                                    to="/emailTemplate"
                                                    onClick={handleMobileDrawerClose}
                                                    sx={{
                                                        py: 1.5,
                                                        px: 4,
                                                        color: location.pathname === "/emailTemplate" ? '#F8991D' : '#212b36',
                                                        fontWeight: location.pathname === "/emailTemplate" ? 600 : 400,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                                            color: '#F8991D',
                                                        },
                                                    }}
                                                >
                                                    <ListItemText primary="Email Template" />
                                                </ListItemButton>
                                            </ListItem>
                                        )}
                                    </List>
                                </Collapse>
                            </>
                        )}

                        <Divider sx={{ my: 1 }} />
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    handleMobileDrawerClose();
                                    handleLogout();
                                }}
                                sx={{
                                    py: 1.5,
                                    px: 2,
                                    color: '#212b36',
                                    '&:hover': {
                                        backgroundColor: 'rgba(145, 158, 171, 0.08)',
                                    },
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 40 }}>
                                    <Iconify icon="eva:log-out-fill" width={20} height={20} sx={{ color: '#637381' }} />
                                </ListItemIcon>
                                <ListItemText primary="Sign Out" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Drawer>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', borderBottom: '1px solid rgba(8, 13, 17, 0.16)' }}>
                {/* Company Name/Logo Section */}
                <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 1 }}>
                    {isMobile && (
                        <IconButton
                            onClick={handleMobileDrawerToggle}
                            sx={{ color: '#e27172' }}
                        >
                            <Iconify icon="eva:menu-fill" width={24} height={24} />
                        </IconButton>
                    )}
                    <Link
                        to={`/dashboard/${accessToken}/${userId}`}
                        className="logo-area align-items-center scrollto me-auto me-lg-0"
                        style={{ textDecoration: 'none', color: '#F8991D', fontWeight: 'bold', fontSize: '1rem', textTransform: 'uppercase' }}
                    >
                        {SiteName}
                    </Link>
                </Box>

                {/* Menu Navigation */}
                {!isMobile && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, justifyContent: 'center' }}>
                        {!isPurchase && (
                            <>
                                <Button
                                    component={Link}
                                    to={`/dashboard/${accessToken}/${userId}`}
                                    sx={{
                                        color: location.pathname === `/dashboard/${accessToken}/${userId}` ? "#F8991D" : "#000",
                                        textTransform: "none",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        py: 1,

                                        "&:hover": {
                                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                                            color: "#F8991D"
                                        },
                                        "&:active": {
                                            color: "#F8991D"
                                        }
                                    }}
                                >
                                    Dashboard
                                </Button>

                                {hasPermission('Company Settings') && (
                                    <Button
                                        component={Link}
                                        to="/dashboard/company-settings"
                                        sx={{
                                            color: location.pathname === "/dashboard/company-settings" ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Company Settings
                                    </Button>
                                )}

                                {(hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                                    <Button
                                        component={Link}
                                        to="/settings/change_permissions/1"
                                        sx={{
                                            color: location.pathname.includes("/settings/change_permissions") ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Role Permissions
                                    </Button>
                                )}
                                {(hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                                    <Button
                                        component={Link}
                                        to="/settings/product_form_fields"
                                        sx={{
                                            color: location.pathname.includes("/settings/product_form_fields") ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Product
                                    </Button>
                                )}
                                {(hasPermission('Role Permission') || hasPermission('Role Permissions')) && (
                                    <Button
                                        component={Link}
                                        to="/settings/customer_form_fields"
                                        sx={{
                                            color: location.pathname.includes("/settings/customer_form_fields") ? "#F8991D" : "#000",
                                            textTransform: "none",
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                            py: 1.5,
                                            px: 1.8,
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                color: "#F8991D"
                                            },
                                            "&:active": {
                                                color: "#F8991D"
                                            }
                                        }}
                                    >
                                        Customer
                                    </Button>
                                )}
                            </>
                        )}

                        {/* Sales */}
                        {(!isPurchase && ((hasAnyPermission(['NewSales', 'SalesHistory', 'SalesQuickOrder', 'HoldList']) || isRole(20)) || hasPermission('HoldList') || hasPermission('SalesHistory'))) ? (
                            <>
                                <Button
                                    onClick={(e) => handleMenuOpen(e, "sales")}
                                    sx={{
                                        color: isRouteActive(['/sales/newsales', '/sales/shistory', '/sales/reject_sales', '/sales/IncompleteOrderList', '/sales/quick-order', '/sales/inventoryreport', '/sales/epos', '/sales/holdList']) ? "#F8991D" : "#000",
                                        textTransform: "none",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        py: 1.5,

                                        "&:hover": {
                                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                                            color: "#F8991D"
                                        }
                                    }}
                                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                >
                                    Sales
                                </Button>
                                {anchorEls.sales && isValidAnchor(anchorEls.sales) && (
                                    <Menu
                                        anchorEl={anchorEls.sales}
                                        open={true}
                                        onClose={() => handleMenuClose("sales")}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        PaperProps={{
                                            sx: {
                                                mt: 1,
                                                minWidth: 200,
                                                boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                borderRadius: 1,
                                            },
                                        }}
                                    >
                                        {((orderProcessSequence === "4") || (orderStatus === "2" && orderProcessSequence === "2")) ? (
                                            <>
                                                {hasPermission('HoldList') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/holdList"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/holdList"}
                                                        sx={
                                                            {
                                                                color: location.pathname === "/sales/holdList" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/sales/holdList" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }
                                                        }
                                                    >
                                                        Hold List
                                                    </MenuItem>
                                                )}
                                                {hasPermission('SalesHistory') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/shistory"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/shistory"}
                                                        sx={{
                                                            color: location.pathname === "/sales/shistory" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/shistory" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Order History
                                                    </MenuItem>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {hasPermission('NewSales') && !(orderStatus === "2" && orderProcessSequence === "1") && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/newsales"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/newsales"}
                                                        sx={{
                                                            color: location.pathname === "/sales/newsales" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/newsales" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}

                                                    >
                                                        New Sales
                                                    </MenuItem>
                                                )}
                                                {hasPermission('SalesHistory') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/shistory"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/shistory"}
                                                        sx={{
                                                            color: location.pathname === "/sales/shistory" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/shistory" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Order History
                                                    </MenuItem>
                                                )}
                                                {hasPermission('HoldList') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/holdList"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/holdList"}
                                                        sx={
                                                            {
                                                                color: location.pathname === "/sales/holdList" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/sales/holdList" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }
                                                        }
                                                    >
                                                        Hold List
                                                    </MenuItem>
                                                )}
                                                {hasPermission('SalesHistory') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/reject_sales"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/reject_sales"}
                                                        sx={{
                                                            color: location.pathname === "/sales/reject_sales" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/reject_sales" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Reject Sales History
                                                    </MenuItem>
                                                )}
                                                {/* {config.PREFIX === "atr" && isRole(8) && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/IncompleteOrderList"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/IncompleteOrderList"}
                                                        sx={{
                                                            color: location.pathname === "/sales/IncompleteOrderList" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/IncompleteOrderList" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Customer Incomplete Order
                                                    </MenuItem>
                                                )} */}
                                                {isRole(20) && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/quick-order"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/quick-order"}
                                                        sx={{
                                                            color: location.pathname === "/sales/quick-order" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/quick-order" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Tele Caller
                                                    </MenuItem>
                                                )}
                                                {hasPermission('Inventory_Report') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/InventoryReport"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/InventoryReport"}
                                                        sx={{
                                                            color: location.pathname === "/sales/InventoryReport" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/InventoryReport" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Inventory Report
                                                    </MenuItem>
                                                )}
                                                {showEposNavItem && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/sales/epos/new"
                                                        onClick={() => handleMenuClose("sales")}
                                                        selected={location.pathname === "/sales/epos/new"}
                                                        sx={{
                                                            color: location.pathname === "/sales/epos/new" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/sales/epos/new" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Epos
                                                    </MenuItem>
                                                )}
                                            </>
                                        )}
                                    </Menu>
                                )}
                            </>
                        ) : null}

                        {/* Dispatch & Deliveries */}
                        {!isPurchase && hasAnyPermission(['CreateManifest', 'Trip']) && (
                            <>
                                <Button
                                    onClick={(e) => handleMenuOpen(e, "delivery")}
                                    sx={{
                                        color: isRouteActive(['/delivery/route_planing', '/manifest_list', '/open_trips', '/complete_trips']) ? "#F8991D" : "#000",
                                        textTransform: "none",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        py: 1.5,
                                        px: 1,
                                        whiteSpace: 'nowrap',
                                        "&:hover": {
                                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                                            color: "#F8991D"
                                        }
                                    }}
                                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                >
                                    Dispatch & Deliveries
                                </Button>
                                {anchorEls.delivery && isValidAnchor(anchorEls.delivery) && (
                                    <Menu
                                        anchorEl={anchorEls.delivery}
                                        open={true}
                                        onClose={() => handleMenuClose("delivery")}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        PaperProps={{
                                            sx: {
                                                mt: 1,
                                                minWidth: 200,
                                                boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                borderRadius: 1,
                                            },
                                        }}
                                    >
                                        {orderProcessSequence !== "4" && (
                                            <>
                                                {hasPermission('PickingList') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to={isSinglePicking === 'Y' ? "/picking/picking_list" : "/picking/picking_list"}
                                                        onClick={() => handleMenuClose("picking")}
                                                        selected={location.pathname === "/picking/picking_list" || location.pathname === "/picking/picking_list"}
                                                        sx={{
                                                            color: (location.pathname === "/picking/picking_list" || location.pathname === "/picking/picking_list") ? "#212b36" : "#212b36",
                                                            fontWeight: (location.pathname === "/picking/picking_list" || location.pathname === "/picking/picking_list") ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Picking List
                                                    </MenuItem>
                                                )}

                                                {isSinglePicking === 'N' && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/picking/short_qty"
                                                        onClick={() => handleMenuClose("picking")}
                                                        selected={location.pathname === "/picking/short_qty"}
                                                        sx={{
                                                            color: location.pathname === "/picking/short_qty" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/picking/short_qty" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Short QTY
                                                    </MenuItem>
                                                )}
                                            </>
                                        )}
                                        {hasPermission('CreateManifest') && (
                                            <>
                                                <MenuItem
                                                    component={Link}
                                                    to="/delivery/route_planing"
                                                    onClick={() => handleMenuClose("delivery")}
                                                    selected={location.pathname === "/delivery/route_planing"}
                                                    sx={{
                                                        color: location.pathname === "/delivery/route_planing" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/delivery/route_planing" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Create Manifest
                                                </MenuItem>
                                                <MenuItem
                                                    component={Link}
                                                    to="/manifest_list"
                                                    onClick={() => handleMenuClose("delivery")}
                                                    selected={location.pathname === "/manifest_list"}
                                                    sx={{
                                                        color: location.pathname === "/manifest_list" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/manifest_list" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Manifest List
                                                </MenuItem>
                                            </>
                                        )}
                                        {hasPermission('Trip') && (
                                            <>
                                                <MenuItem
                                                    component={Link}
                                                    to="/open_trips"
                                                    onClick={() => handleMenuClose("delivery")}
                                                    selected={location.pathname === "/open_trips"}
                                                    sx={{
                                                        color: location.pathname === "/open_trips" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/open_trips" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Trip
                                                </MenuItem>
                                                {/* <MenuItem
                                        component={Link}
                                        to="/complete_trips"
                                        onClick={() => handleMenuClose("delivery")}
                                        selected={location.pathname === "/complete_trips"}
                                        sx={{
                                            color: location.pathname === "/complete_trips" ? "#212b36" : "#212b36",
                                            fontWeight: location.pathname === "/complete_trips" ? 600 : 400,
                                            "&:hover": {
                                                color: "#dc3545"
                                            }
                                        }}
                                    >
                                        Complete Trip
                                    </MenuItem> */}
                                            </>
                                        )}
                                    </Menu>
                                )}
                            </>
                        )}

                        {/* Master */}
                        {!isPurchase && hasAnyPermission(['Product', 'ProductsPriceVariation', 'Supplier', 'Users', 'ProductCategories', 'Brand', 'Unit', 'Customers', 'CreditFacility', 'Adjustments', 'StockTake', 'OrderProductDiscount', 'Catalogue', 'Shopify Product List', 'Amazon Product List']) && (
                            <>
                                <Button
                                    onClick={(e) => handleMenuOpen(e, "product-master")}
                                    sx={{
                                        color: isRouteActive(['/products', '/products_price_variation', '/supplier', '/users', '/product_category', '/brands', '/units', '/customers', '/contralist', '/shopifyproductlist', '/amazonproductlist']) ? "#F8991D" : "#000",
                                        textTransform: "none",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        py: 1.5,

                                        "&:hover": {
                                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                                            color: "#F8991D"
                                        }
                                    }}
                                    endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                >
                                    Master
                                </Button>
                                {anchorEls["product-master"] && isValidAnchor(anchorEls["product-master"]) && (
                                    <Menu
                                        anchorEl={anchorEls["product-master"]}
                                        open={true}
                                        onClose={() => handleMenuClose("product-master")}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        PaperProps={{
                                            sx: {
                                                mt: 1,
                                                minWidth: 220,
                                                maxHeight: 400,
                                                overflowY: 'auto',
                                                boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                borderRadius: 1,
                                            },
                                        }}
                                    >
                                        {hasPermission('Product') && (
                                            <MenuItem
                                                component={Link}
                                                to="/products"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/products"}
                                                sx={{
                                                    color: location.pathname === "/products" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/products" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Products
                                            </MenuItem>
                                        )}
                                        {config.PREFIX === 'tsc' && (
                                            <MenuItem
                                                component={Link}
                                                to="/shopifyProductList"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/shopifyProductList"}
                                                sx={{
                                                    color: location.pathname === "/shopifyProductList" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/shopifyProductList" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Shopify List
                                            </MenuItem>
                                        )}
                                        {hasPermission('ProductsPriceVariation') && (
                                            <MenuItem
                                                component={Link}
                                                to="/products_price_variation"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/products_price_variation"}
                                                sx={{
                                                    color: location.pathname === "/products_price_variation" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/products_price_variation" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Product Price Variation
                                            </MenuItem>
                                        )}
                                        {hasPermission('Supplier') && (
                                            <MenuItem
                                                component={Link}
                                                to="/supplier"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/supplier"}
                                                sx={{
                                                    color: location.pathname === "/supplier" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/supplier" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Suppliers
                                            </MenuItem>
                                        )}
                                        {hasPermission('Users') && (
                                            <MenuItem
                                                component={Link}
                                                to="/users"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/users"}
                                                sx={{
                                                    color: location.pathname === "/users" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/users" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Users
                                            </MenuItem>
                                        )}
                                        {hasPermission('ProductCategories') && (
                                            <MenuItem
                                                component={Link}
                                                to="/product_category"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/product_category"}
                                                sx={{
                                                    color: location.pathname === "/product_category" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/product_category" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Product Categories
                                            </MenuItem>
                                        )}
                                        {hasPermission('Brand') && (
                                            <MenuItem
                                                component={Link}
                                                to="/Brands"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/Brands"}
                                                sx={{
                                                    color: location.pathname === "/Brands" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/Brands" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Brands
                                            </MenuItem>
                                        )}
                                        {hasPermission('Unit') && (
                                            <MenuItem
                                                component={Link}
                                                to="/Units"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/Units"}
                                                sx={{
                                                    color: location.pathname === "/Units" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/Units" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Units
                                            </MenuItem>
                                        )}
                                        {hasPermission('Customers') && (
                                            <MenuItem
                                                component={Link}
                                                to="/customers"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/customers"}
                                                sx={{
                                                    color: location.pathname === "/customers" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/customers" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Customers
                                            </MenuItem>
                                        )}
                                        {showContraPrice === 'Y' && (
                                            <MenuItem
                                                component={Link}
                                                to="/ContraList"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/ContraList"}
                                                sx={{
                                                    color: location.pathname === "/ContraList" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/ContraList" ? 600 : 400,
                                                    "&:hover": {
                                                        color: "#F8991D"
                                                    }
                                                }}
                                            >
                                                Contra Price Customers
                                            </MenuItem>
                                        )}
                                        {shopifyConnectivity === 'Y' && hasPermission('Shopify Product List') && (
                                            <MenuItem
                                                component={Link}
                                                to="/shopifyProductList"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/shopifyProductList"}
                                                sx={{
                                                    color: location.pathname === "/shopifyProductList" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/shopifyProductList" ? 600 : 400,
                                                }}
                                            >
                                                Shopify Product List
                                            </MenuItem>
                                        )}
                                        {amazonConnectivity === 'Y' && hasPermission('Amazon Product List') && (
                                            <MenuItem
                                                component={Link}
                                                to="/amazonProductList"
                                                onClick={() => handleMenuClose("product-master")}
                                                selected={location.pathname === "/amazonProductList"}
                                                sx={{
                                                    color: location.pathname === "/amazonProductList" ? "#212b36" : "#212b36",
                                                    fontWeight: location.pathname === "/amazonProductList" ? 600 : 400,
                                                }}
                                            >
                                                Amazon Product List
                                            </MenuItem>
                                        )}
                                    </Menu>
                                )}
                            </>
                        )}

                        {/* Report */}
                        {(isPurchase || hasAnyPermission(['CustomernotOrder', 'DriverReport', 'InventorySales', 'Inventory_Report', 'MISreport', 'Cross-Off', 'Sales-Rep', 'ProfitLoss'])) && (
                            <>
                                {isPurchase ? (
                                    <>
                                        <Button
                                            onClick={(e) => handleMenuOpen(e, "reports")}
                                            sx={{
                                                color: isRouteActive(['/reports/PurchaseOrderReport']) ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)"
                                                }
                                            }}
                                            endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                        >
                                            Report
                                        </Button>
                                        {anchorEls.reports && isValidAnchor(anchorEls.reports) && (
                                            <Menu
                                                anchorEl={anchorEls.reports}
                                                open={true}
                                                onClose={() => handleMenuClose("reports")}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                PaperProps={{
                                                    sx: {
                                                        mt: 1,
                                                        minWidth: 200,
                                                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                        borderRadius: 1,
                                                    },
                                                }}
                                            >
                                                <MenuItem
                                                    component={Link}
                                                    to="/reports/PurchaseOrderReport"
                                                    onClick={() => handleMenuClose("reports")}
                                                    selected={location.pathname === "/reports/PurchaseOrderReport"}
                                                    sx={{
                                                        color: location.pathname === "/reports/PurchaseOrderReport" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/reports/PurchaseOrderReport" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Purchase Report
                                                </MenuItem>
                                            </Menu>
                                        )}
                                    </>
                                ) : (
                                    <>

                                        <Button
                                            onClick={(e) => handleMenuOpen(e, "reports")}
                                            sx={{
                                                color: isRouteActive(['/reports/sales_report', '/reports/inventory_sales_report', '/reports/sales_product_report', '/reports/customer_not_order_report', '/reports/dsr_report', '/reports/daysummaryreport', '/reports/salesorderreport', '/reports/customermonthlysalesreport', '/reports/profit_loss_report', '/reports/transactionsreport', '/reports/mis_report', '/reports/mis_product_report', '/reports/stock_report', '/reports/batchwise_stock_report', '/reports/newproductstransactionreport', '/reports/missing_order', '/reports/lat_long_report', '/reports/purchaseorderreport']) ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,

                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)"
                                                }
                                            }}
                                            endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                        >
                                            Report
                                        </Button>
                                        {anchorEls.reports && isValidAnchor(anchorEls.reports) && (
                                            <>
                                            <Menu
                                                anchorEl={anchorEls.reports}
                                                open={true}
                                                onClose={() => handleMenuClose("reports")}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                disableAutoFocusItem
                                                MenuListProps={{
                                                    onMouseLeave: () => {
                                                        if (!reportsFlyoutRef.current) {
                                                            handleMenuClose("reports");
                                                        }
                                                    }
                                                }}
                                                PaperProps={{
                                                    sx: {
                                                        mt: 1,
                                                        minWidth: 200,
                                                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                        borderRadius: 1,
                                                        pointerEvents: 'auto',
                                                    },
                                                }}
                                            >
                                                <MenuItem
                                                    onMouseEnter={(e) => openReportsFlyout(e, "sales")}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        openReportsFlyout(e, "sales");
                                                    }}
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.08)"
                                                        }
                                                    }}
                                                >
                                                    <MuiListItemText>Sales</MuiListItemText>
                                                    <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                                                </MenuItem>
                                                <MenuItem
                                                    onMouseEnter={(e) => openReportsFlyout(e, "account")}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        openReportsFlyout(e, "account");
                                                    }}
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.08)"
                                                        }
                                                    }}
                                                >
                                                    <MuiListItemText>Account</MuiListItemText>
                                                    <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                                                </MenuItem>
                                                <MenuItem
                                                    onMouseEnter={(e) => openReportsFlyout(e, "inventory")}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        openReportsFlyout(e, "inventory");
                                                    }}
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.08)"
                                                        }
                                                    }}
                                                >
                                                    <MuiListItemText>Inventory</MuiListItemText>
                                                    <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                                                </MenuItem>
                                                <MenuItem
                                                    onMouseEnter={(e) => openReportsFlyout(e, "other")}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        openReportsFlyout(e, "other");
                                                    }}
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.08)",
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    <MuiListItemText >Other</MuiListItemText>
                                                    <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                                                </MenuItem>
                                                <MenuItem
                                                    onMouseEnter={(e) => openReportsFlyout(e, "purchase")}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        openReportsFlyout(e, "purchase");
                                                    }}
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.08)",
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    <MuiListItemText>Purchase</MuiListItemText>
                                                    <Iconify icon="eva:arrow-ios-forward-fill" width={16} height={16} sx={{ ml: 1 }} />
                                                </MenuItem>
                                                <MenuItem
                                                    component={Link}
                                                    to="/reports/LocationTrackReport"
                                                    onClick={() => handleMenuClose("reports")}
                                                    selected={location.pathname === "/reports/LocationTrackReport"}
                                                    sx={{
                                                        color: location.pathname === "/reports/LocationTrackReport" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/reports/LocationTrackReport" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                 <MuiListItemText>Loacation Track Report</MuiListItemText>
                                                </MenuItem>
                                            </Menu>
                                            {reportsFlyout && reportsFlyout.anchor && isValidAnchor(reportsFlyout.anchor) && (
                                                <Menu
                                                    key={reportsFlyout.key}
                                                    anchorEl={reportsFlyout.anchor}
                                                    open={true}
                                                    disableEnforceFocus
                                                    slotProps={flyoutMenuSlotProps}
                                                    onClose={() => setReportsFlyout(null)}
                                                    anchorOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'left',
                                                    }}
                                                    disableAutoFocusItem
                                                    MenuListProps={{
                                                        onMouseLeave: () => setReportsFlyout(null)
                                                    }}
                                                    PaperProps={{
                                                        sx: {
                                                            ml: 0.5,
                                                            minWidth: 220,
                                                            maxHeight: 400,
                                                            overflowY: 'auto',
                                                            boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                            borderRadius: 1,
                                                            pointerEvents: 'auto',
                                                        },
                                                    }}
                                                >
                                                    {reportsFlyout.key === "sales" && (
                                                        <>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/sales_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/sales_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/sales_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/sales_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Sales Rep Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/inventory_sales_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/inventory_sales_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/inventory_sales_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/inventory_sales_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Inventory Sales Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/sales_product_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/sales_product_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/sales_product_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/sales_product_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Sales Products Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/customer_not_order_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/customer_not_order_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/customer_not_order_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/customer_not_order_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Customer Not Order
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/dsr_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/dsr_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/dsr_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/dsr_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            DSR Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/DaySummaryReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/DaySummaryReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/DaySummaryReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/DaySummaryReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Day Summary Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/SalesOrderReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/SalesOrderReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/SalesOrderReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/SalesOrderReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Sales Order Report
                                                        </MenuItem>
                                                       
                                                        {(config.PREFIX == "eve" || config.PREFIX == "ve" || config.PREFIX == "tsc") && (
                                                        <>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/PushInvoiceReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/PushInvoiceReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/PushInvoiceReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/PushInvoiceReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Push Invoice Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/PushCreditNoteReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/PushCreditNoteReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/PushCreditNoteReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/PushCreditNoteReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Push Credit Note Report
                                                        </MenuItem>
                                                        </>
                                                        )}
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/CustomerMonthlySalesReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/CustomerMonthlySalesReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/CustomerMonthlySalesReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/CustomerMonthlySalesReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Customer Monthly Sales Report
                                                        </MenuItem>
                                                        </>
                                                    )}
                                                    {reportsFlyout.key === "account" && (
                                                        <>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/profit_loss_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/profit_loss_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/profit_loss_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/profit_loss_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Profit and Loss
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/TransactionsReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/TransactionsReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/TransactionsReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/TransactionsReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Transaction Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/mis_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/mis_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/mis_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/mis_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            MIS Order Wise
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/mis_product_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/mis_product_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/mis_product_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/mis_product_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            MIS Product Wise
                                                        </MenuItem>
                                                        </>
                                                    )}
                                                    {reportsFlyout.key === "inventory" && (
                                                        <>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/stock_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/stock_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/stock_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/stock_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Stock Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/batchWise_stock_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/batchWise_stock_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/batchWise_stock_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/batchWise_stock_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Batch Wise Stock Report
                                                        </MenuItem>
                                                        {isBritWholesaleUi() && (
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/brit_dual_stock"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/brit_dual_stock"}
                                                            sx={{
                                                                color: location.pathname === "/reports/brit_dual_stock" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/brit_dual_stock" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Brit dual stock
                                                        </MenuItem>
                                                        )}
                                                        {isBritWholesaleUi() && (
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/brit_stock_transfer_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/brit_stock_transfer_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/brit_stock_transfer_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/brit_stock_transfer_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Brit stock transfer report
                                                        </MenuItem>
                                                        )}
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/NewProductsTransactionReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/NewProductsTransactionReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/NewProductsTransactionReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/NewProductsTransactionReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Products Transaction Report
                                                        </MenuItem>
                                                        {hasPermission('Inventory_Report') && (
                                                            <MenuItem
                                                                component={Link}
                                                                to="/sales/InventoryReport"
                                                                onClick={() => {
                                                                    handleMenuClose("reports");
                                                                }}
                                                                selected={location.pathname === "/sales/InventoryReport"}
                                                                sx={{
                                                                    color: location.pathname === "/sales/InventoryReport" ? "#212b36" : "#212b36",
                                                                    fontWeight: location.pathname === "/sales/InventoryReport" ? 600 : 400,
                                                                    "&:hover": {
                                                                        color: "#F8991D"
                                                                    }
                                                                }}
                                                            >
                                                                Inventory Report
                                                            </MenuItem>
                                                        )}
                                                        </>
                                                    )}
                                                    {reportsFlyout.key === "other" && (
                                                        <>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/missing_order"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/missing_order"}
                                                            sx={{
                                                                color: location.pathname === "/reports/missing_order" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/missing_order" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Cross Off Report
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/lat_long_report"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/lat_long_report"}
                                                            sx={{
                                                                color: location.pathname === "/reports/lat_long_report" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/lat_long_report" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Order Location Report
                                                        </MenuItem>
                                                        </>
                                                    )}
                                                    {reportsFlyout.key === "purchase" && (
                                                        <MenuItem
                                                            component={Link}
                                                            to="/reports/PurchaseOrderReport"
                                                            onClick={() => {
                                                                handleMenuClose("reports");
                                                            }}
                                                            selected={location.pathname === "/reports/PurchaseOrderReport"}
                                                            sx={{
                                                                color: location.pathname === "/reports/PurchaseOrderReport" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/reports/PurchaseOrderReport" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Purchase Report
                                                        </MenuItem>
                                                    )}

                                                </Menu>
                                            )}
                                        </>
                                        )}
                                    </>
                                )}

                                {/* Purchases */}
                                {(hasAnyPermission(['PurchasesOrder', 'PurchasesHistory', 'StockAdjustment']) || isPurchase) && (
                                    <>
                                        <Button
                                            onClick={(e) => handleMenuOpen(e, "purchases")}
                                            sx={{
                                                color: isRouteActive(['/purchases/purchases_order', '/purchases/purchases_grn', '/purchases/stockadjustment', '/purchases/edit', '/purchases/add']) ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,

                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                }
                                            }}
                                            endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                        >
                                            Purchases
                                        </Button>
                                        {anchorEls.purchases && isValidAnchor(anchorEls.purchases) && (
                                            <Menu
                                                anchorEl={anchorEls.purchases}
                                                open={true}
                                                onClose={() => handleMenuClose("purchases")}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                PaperProps={{
                                                    sx: {
                                                        mt: 1,
                                                        minWidth: 200,
                                                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                        borderRadius: 1,
                                                    },
                                                }}
                                            >
                                                {hasPermission('PurchasesOrder') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/purchases/purchases_order"
                                                        onClick={() => handleMenuClose("purchases")}
                                                        selected={location.pathname === "/purchases/purchases_order"}
                                                        sx={{
                                                            color: location.pathname === "/purchases/purchases_order" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/purchases/purchases_order" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Purchases Order
                                                    </MenuItem>
                                                )}
                                                {hasPermission('PurchasesHistory') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/purchases/purchases_grn"
                                                        onClick={() => handleMenuClose("purchases")}
                                                        selected={location.pathname === "/purchases/purchases_grn"}
                                                        sx={{
                                                            color: location.pathname === "/purchases/purchases_grn" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/purchases/purchases_grn" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Purchases History
                                                    </MenuItem>
                                                )}
                                                {hasPermission('StockAdjustment') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/purchases/StockAdjustment"
                                                        onClick={() => handleMenuClose("purchases")}
                                                        selected={location.pathname === "/purchases/StockAdjustment"}
                                                        sx={{
                                                            color: location.pathname === "/purchases/StockAdjustment" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/purchases/StockAdjustment" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Stock Adjustment
                                                    </MenuItem>
                                                )}
                                            </Menu>
                                        )}
                                    </>
                                )}

                                {/* Account */}
                                {!isPurchase && hasAnyPermission(['ReceivedPayments', 'CustomerAccount', 'PaymentLedger', 'BankLedger']) && (
                                    <>
                                        <Button
                                            onClick={(e) => handleMenuOpen(e, "account")}
                                            sx={{
                                                color: isRouteActive(['/account/push_sage', '/account/payments', '/account/customer_accounts', '/account/customer_transaction_enquiry', '/account/supplier_ledger', '/account/payment_ladger', '/account/my_ledger', '/account/product_ledger', '/reports/payment_collection', '/stock_take/history']) ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,

                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                }
                                            }}
                                            endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                        >
                                            Account
                                        </Button>
                                        {anchorEls.account && isValidAnchor(anchorEls.account) && (
                                            <Menu
                                                anchorEl={anchorEls.account}
                                                open={true}
                                                onClose={() => handleMenuClose("account")}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                PaperProps={{
                                                    sx: {
                                                        mt: 1,
                                                        minWidth: 200,
                                                        maxHeight: 400,
                                                        overflowY: 'auto',
                                                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                        borderRadius: 1,
                                                    },
                                                }}
                                            >
                                                {accessToken === "dds" && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/account/push_sage"
                                                        onClick={() => handleMenuClose("account")}
                                                        selected={location.pathname === "/account/push_sage"}
                                                        sx={{
                                                            color: location.pathname === "/account/push_sage" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/account/push_sage" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Push to Sage
                                                    </MenuItem>
                                                )}
                                                {hasPermission('ReceivedPayments') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/account/payments"
                                                        onClick={() => handleMenuClose("account")}
                                                        selected={location.pathname === "/account/payments"}
                                                        sx={{
                                                            color: location.pathname === "/account/payments" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/account/payments" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Received Payments
                                                    </MenuItem>
                                                )}
                                                {hasPermission('CustomerAccount') && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/account/customer_accounts"
                                                        onClick={() => handleMenuClose("account")}
                                                        selected={location.pathname === "/account/customer_accounts"}
                                                        sx={{
                                                            color: location.pathname === "/account/customer_accounts" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/account/customer_accounts" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Customer Accounts
                                                    </MenuItem>
                                                )}
                                                {(config.PREFIX === 'rhp' || config.PREFIX === 'hp' || accessToken === 'rhp' || accessToken === 'hp') && (hasPermission('CustomerTransactionEnquiry') || hasPermission('CustomerAccount')) && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/account/customer_transaction_enquiry"
                                                        onClick={() => handleMenuClose("account")}
                                                        selected={location.pathname === "/account/customer_transaction_enquiry"}
                                                        sx={{
                                                            color: location.pathname === "/account/customer_transaction_enquiry" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/account/customer_transaction_enquiry" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Customer Transaction Enquiry
                                                    </MenuItem>
                                                )}
                                                <MenuItem
                                                    component={Link}
                                                    to="/account/supplier_ledger"
                                                    onClick={() => handleMenuClose("account")}
                                                    selected={location.pathname === "/account/supplier_ledger"}
                                                    sx={{
                                                        color: location.pathname === "/account/supplier_ledger" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/account/supplier_ledger" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Supplier Ledger
                                                </MenuItem>
                                                {hasPermission('PaymentLedger') && (
                                                    <>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/account/payment_ladger"
                                                            onClick={() => handleMenuClose("account")}
                                                            selected={location.pathname === "/account/payment_ladger"}
                                                            sx={{
                                                                color: location.pathname === "/account/payment_ladger" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/account/payment_ladger" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            Payment Ledger
                                                        </MenuItem>
                                                        <MenuItem
                                                            component={Link}
                                                            to="/account/my_ledger"
                                                            onClick={() => handleMenuClose("account")}
                                                            selected={location.pathname === "/account/my_ledger"}
                                                            sx={{
                                                                color: location.pathname === "/account/my_ledger" ? "#212b36" : "#212b36",
                                                                fontWeight: location.pathname === "/account/my_ledger" ? 600 : 400,
                                                                "&:hover": {
                                                                    color: "#F8991D"
                                                                }
                                                            }}
                                                        >
                                                            My Ledger
                                                        </MenuItem>
                                                    </>
                                                )}
                                                <MenuItem
                                                    component={Link}
                                                    to="/account/product_ledger"
                                                    onClick={() => handleMenuClose("account")}
                                                    selected={location.pathname === "/account/product_ledger"}
                                                    sx={{
                                                        color: location.pathname === "/account/product_ledger" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/account/product_ledger" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Product Ledger
                                                </MenuItem>
                                                <MenuItem
                                                    component={Link}
                                                    to="/reports/payment_collection"
                                                    onClick={() => handleMenuClose("account")}
                                                    selected={location.pathname === "/reports/payment_collection"}
                                                    sx={{
                                                        color: location.pathname === "/reports/payment_collection" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/reports/payment_collection" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Payment Collected
                                                </MenuItem>
                                                <MenuItem
                                                    component={Link}
                                                    to="/stock_take/history"
                                                    onClick={() => handleMenuClose("account")}
                                                    selected={location.pathname === "/stock_take/history"}
                                                    sx={{
                                                        color: location.pathname === "/stock_take/history" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/stock_take/history" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Stock Take
                                                </MenuItem>
                                            </Menu>
                                        )}
                                    </>
                                )}

                                {/* Return */}
                                {!isPurchase && hasPermission('ReturnList') && (
                                    <>
                                        <Button
                                            onClick={(e) => handleMenuOpen(e, "return")}
                                            sx={{
                                                color: isRouteActive(['/return_list']) ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,

                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                }
                                            }}
                                            endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                        >
                                            Return
                                        </Button>
                                        {anchorEls.return && isValidAnchor(anchorEls.return) && (
                                            <Menu
                                                anchorEl={anchorEls.return}
                                                open={true}
                                                onClose={() => handleMenuClose("return")}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                PaperProps={{
                                                    sx: {
                                                        mt: 1,
                                                        minWidth: 200,
                                                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                        borderRadius: 1,
                                                    },
                                                }}
                                            >
                                                <MenuItem
                                                    component={Link}
                                                    to="/return_list"
                                                    onClick={() => handleMenuClose("return")}
                                                    selected={location.pathname === "/return_list"}
                                                    sx={{
                                                        color: location.pathname === "/return_list" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/return_list" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Return List
                                                </MenuItem>
                                            </Menu>
                                        )}
                                    </>
                                )}

                                {/* Promotion */}
                                {!isPurchase && hasAnyPermission(['Catalogue', 'SliderSettings', 'Promotions', 'Promotion', 'EmailTemplate']) && (
                                    <>
                                        <Button
                                            onClick={(e) => handleMenuOpen(e, "Promotions")}
                                            sx={{
                                                color: isRouteActive(['/catalogue', '/slider_settings', '/promotions/promos', '/emailtemplate']) ? "#F8991D" : "#000",
                                                textTransform: "none",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                py: 1.5,

                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                    color: "#F8991D"
                                                }
                                            }}
                                            endIcon={<Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />}
                                        >
                                            Settings
                                        </Button>
                                        {anchorEls.Promotions && isValidAnchor(anchorEls.Promotions) && (
                                            <Menu
                                                anchorEl={anchorEls.Promotions}
                                                open={true}
                                                onClose={() => handleMenuClose("Promotions")}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                PaperProps={{
                                                    sx: {
                                                        mt: 1,
                                                        minWidth: 200,
                                                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                        borderRadius: 1,
                                                    },
                                                }}
                                            >
                                                {hasPermission('Catalogue') && (accessToken != "eve" && accessToken != "ve" && accessToken != "ayt") && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/Catalogue"
                                                        onClick={() => handleMenuClose("Promotions")}
                                                        selected={location.pathname === "/Catalogue"}
                                                        sx={{
                                                            color: location.pathname === "/Catalogue" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/Catalogue" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Catalogue
                                                    </MenuItem>
                                                )}
                                                <MenuItem
                                                    component={Link}
                                                    to="/slider_settings"
                                                    onClick={() => handleMenuClose("Promotions")}
                                                    selected={location.pathname === "/slider_settings"}
                                                    sx={{
                                                        color: location.pathname === "/slider_settings" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/slider_settings" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Slider Settings
                                                </MenuItem>
                                                {hasPermission('Promotions') && (
                                                <MenuItem
                                                    component={Link}
                                                    to="/Promotions/Promos"
                                                    onClick={() => handleMenuClose("Promotions")}
                                                    selected={location.pathname === "/Promotions/Promos"}
                                                    sx={{
                                                        color: location.pathname === "/Promotions/Promos" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/Promotions/Promos" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Promotions
                                                </MenuItem>
                                                )}
                                                <MenuItem
                                                    component={Link}
                                                    to="/Notifications/Notification"
                                                    onClick={() => handleMenuClose("Promotions")}
                                                    selected={location.pathname === "/Notifications/Notification"}
                                                    sx={{
                                                        color: location.pathname === "/Notifications/Notification" ? "#212b36" : "#212b36",
                                                        fontWeight: location.pathname === "/Notifications/Notification" ? 600 : 400,
                                                        "&:hover": {
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    Notifications
                                                </MenuItem>
                                                {showEmailTemplate === 'Y' && (
                                                    <MenuItem
                                                        component={Link}
                                                        to="/emailTemplate"
                                                        onClick={() => handleMenuClose("Promotions")}
                                                        selected={location.pathname === "/emailTemplate"}
                                                        sx={{
                                                            color: location.pathname === "/emailTemplate" ? "#212b36" : "#212b36",
                                                            fontWeight: location.pathname === "/emailTemplate" ? 600 : 400,
                                                            "&:hover": {
                                                                color: "#F8991D"
                                                            }
                                                        }}
                                                    >
                                                        Email Template
                                                    </MenuItem>
                                                )}
                                            </Menu>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Box>
                )}

                {/* User Profile/Login Section */}
                        {!isMobile && (
                            <Box sx={{ flexShrink: 0, display: 'flex' }}>
                                <ul style={{ display: 'flex', alignItems: 'center', listStyle: 'none', margin: 0, padding: 0 }}>
                                    <li>
                                        <Button
                                            onClick={(e) => handleMenuOpen(e, "profile")}
                                            sx={{
                                                color: "#F8991D",
                                                textTransform: "none",
                                                fontSize: "1rem",
                                                fontWeight: 600,
                                                "&:hover": {
                                                    backgroundColor: "rgba(255, 255, 255, 0.08)"
                                                }
                                            }}
                                        >
                                            {firstName} {lastName ? lastName : ""}
                                        </Button>
                                        {anchorEls.profile && isValidAnchor(anchorEls.profile) && (
                                            <Menu
                                                anchorEl={anchorEls.profile}
                                                open={true}
                                                onClose={() => handleMenuClose("profile")}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                PaperProps={{
                                                    sx: {
                                                        mt: 1,
                                                        minWidth: 180,
                                                        boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                        borderRadius: 1,
                                                    },
                                                }}
                                            >
                                                <MenuItem
                                                    onClick={() => {
                                                        handleMenuClose("profile");
                                                        handleLogout();
                                                    }}
                                                    sx={{
                                                        color: "#212b36",
                                                        "&:hover": {
                                                            backgroundColor: "rgba(145, 158, 171, 0.08)",
                                                            color: "#F8991D"
                                                        }
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <Iconify icon="eva:log-out-fill" width={20} height={20} sx={{ color: "#637381" }} />
                                                    </ListItemIcon>
                                                    <ListItemText>Sign Out</ListItemText>
                                                </MenuItem>
                                            </Menu>
                                        )}
                                    </li>
                                </ul>
                            </Box>
                        )}
            </Box>
            {isRole(20) ? (
                <CustomerListPopup
                    open={customerListPopupOpen}
                    onClose={() => setCustomerListPopupOpen(false)}
                />
            ) : null}
        </>
    );
}
